<section class="error-display">
    <img class="error-image" src="./assets/img/wrecked-car.png">
    <h2>{{status}} - {{message}}</h2>
</section>
